import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import AppMobileMenu from "../AppMobileMenu";
import EnableSlider from "./EnableSlider"

import {
  setEnableClosedSidebar,
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from "../../reducers/ThemeOptions";

import allPaths from "../../route/allPaths";
class HeaderLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      mobile: false,
      activeSecondaryMenuMobile: false,
    };
  }

  toggleEnableClosedSidebar = () => {
    let { enableClosedSidebar, setEnableClosedSidebar } = this.props;
    setEnableClosedSidebar(!enableClosedSidebar);
  };

  state = {
    openLeft: false,
    openRight: false,
    relativeWidth: false,
    width: 280,
    noTouchOpen: false,
    noTouchClose: false,
  };

  pushToHome = () => {
    const { history } = this.props;
    history && history.push(allPaths.HOME_ROUTE)
  }

  render() {
    return (
      <Fragment>
           {/* <AppMobileMenu /> */}
     
        <div className="app-header__logo"  >
        <div className="d-none d-md-block">
          <div className="logo-src cursor-p" onClick={this.pushToHome}/>
          </div>
          <div className="d-block d-md-none">
          <div className="cw-mobile_icon " onClick={this.pushToHome}/> 
          </div>
        {/* <EnableSlider/> */}
        
        </div>
     
       
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
  sideBarItems: state.ThemeOptions.sideBarItems
});

const mapDispatchToProps = (dispatch) => ({
  setEnableClosedSidebar: (enable) => dispatch(setEnableClosedSidebar(enable)),
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
  setEnableMobileMenuSmall: (enable) =>
  dispatch(setEnableMobileMenuSmall(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HeaderLogo));
